import { render } from "./PriceSearchRemark.vue?vue&type=template&id=2715d06e&scoped=true&ts=true"
import script from "./PriceSearchRemark.vue?vue&type=script&lang=ts"
export * from "./PriceSearchRemark.vue?vue&type=script&lang=ts"

import "./PriceSearchRemark.vue?vue&type=style&index=0&id=2715d06e&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2715d06e"]])

export default __exports__